/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { CheckCircle, Warning, Report } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  checkIcon: {
    color: theme.palette.completed,
  },
  warningIcon: {
    color: theme.palette.warning.main,
  },
  errorIcon: {
    color: theme.palette.error.main,
  },
}));

function DialogStatus(props) {
  const classes = useStyles();
  const { variant } = props;

  switch (variant) {
    case 'success':
      return <CheckCircle className={classes.checkIcon} fontSize="large" />;
    case 'warning':
      return <Warning className={classes.warningIcon} fontSize="large" />;
    case 'error':
      return <Report className={classes.errorIcon} fontSize="large" />;
    default:
      return null;
  }
}

DialogStatus.propTypes = {
  variant: PropTypes.string.isRequired,
};

export default DialogStatus;
